import { Component, Input } from "@angular/core";

@Component({
  selector: "evrideo-not-allowed-icon",
  templateUrl: "./not-allowed-icon.component.html",
  styleUrl: "./not-allowed-icon.component.scss",
})
export class NotAllowedIconComponent {
  @Input("width") width: number = 15;
  @Input("height") height: number = 15;

  get viewBox(): string {
    return `0 0 ${this.width} ${this.height}`;
  }
}
